import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHero } from "@/components/marketing/PageHero";
import { CtaRedeApoio } from "@/components/marketing/CtaRedeApoio";
import { PlanCard } from "@/pages/Home";

export default function Planos() {
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["plans"], queryFn: async () => (await api.get("/plans")).data });
  const plans = data?.items || [];
  return (
    <div data-testid="page-planos">
      <PageHero title="Planos" testId="planos-hero" />
      <section className="mc-container py-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1e1b2e]">Escolha o <span className="text-grad">plano ideal</span> para você.</h2>
        <div className="grid md:grid-cols-3 gap-6 mt-12 max-w-5xl mx-auto">
          {plans.map((p) => <PlanCard key={p.id} plan={p} onSelect={() => navigate("/cadastro")} />)}
        </div>
      </section>
      <CtaRedeApoio />
    </div>
  );
}
